import { useEffect, useState } from "react";
import { http, money, dateLabel, time } from "../lib/api";

const Row = ({ label, value, testid, bold }) => (
  <div className={`flex justify-between gap-3 ${bold ? "font-bold text-slate-900 border-t pt-2 mt-1" : ""}`} data-testid={testid}>
    <span>{label}</span><span className="font-mono whitespace-nowrap">{value}</span>
  </div>
);

export const FareBreakdown = ({ b }) => {
  const round = b.offer.slices.length > 1;
  const [legs, setLegs] = useState(b.leg_prices || null);
  useEffect(() => {
    if (round && !b.leg_prices && b.offer.source === "serpapi") http.get(`/bookings/${b.booking_id}/leg-prices`).then((r) => setLegs(r.data)).catch(() => setLegs({ legs: [], separate_total: null }));
  }, [b, round]);
  const p = b.prices;
  const air = p.base_fare + (p.taxes || 0);
  const ok = legs?.separate_total != null;
  const diff = ok ? air - legs.separate_total : 0;
  return (
    <div className="px-6 pt-5 text-sm text-slate-600 space-y-1.5" data-testid="pay-fare-breakdown">
      {b.offer.slices.map((s, i) => (
        <Row key={i} testid={`pay-leg-${i}`}
          label={<><b className="text-slate-900">{round ? (i ? "Return" : "Departure") : "Flight"}</b> · {s.flight_no} · {s.origin}→{s.destination} · {dateLabel(s.depart_at)} {time(s.depart_at)}{legs?.derived === i ? " (rest of round-trip fare)" : ""}</>}
          value={round ? (ok ? money(legs.legs[i]) : legs === null && b.offer.source === "serpapi" ? "…" : "") : money(air)} />
      ))}
      {round && (!ok || diff !== 0) && <Row testid="pay-airfare" label={ok ? (diff < 0 ? "Round-trip saving" : "Round-trip fare adjustment") : "Airfare for both flights"} value={ok ? `${diff < 0 ? "−" : "+"}${money(Math.abs(diff))}` : money(air)} />}
      {round && ok && legs.derived == null && diff < 0 && <div className="rounded-lg bg-[#E8F5E9] text-[#0F9D58] text-xs font-bold px-3 py-2" data-testid="pay-rt-saving-badge">You save {money(-diff)} with this round trip vs 2 separate tickets</div>}
      {round && ok && <Row testid="pay-airfare-total" label="Round-trip airfare (both flights)" value={money(air)} />}
      {[["insurance", "Medical travel insurance"], ["seats", "Seats"], ["meals", "Meals"], ["baggage", "Extra baggage"], ["assured", "Full refund protection"], ["service_fee", "Service fee"]].map(([k, l]) => p[k] ? <Row key={k} testid={`pay-${k}`} label={l} value={money(p[k])} /> : null)}
      {p.discount ? <Row testid="pay-discount" label={p.discount_type === "coupon" || (!p.discount_type && b.coupon) ? `Coupon (${b.coupon})` : "WanderNest instant discount"} value={`−${money(p.discount)}`} /> : null}
      {p.admin_change ? <Row testid="pay-admin-change" label={`Price adjusted by WanderNest${p.admin_reason ? ` (${p.admin_reason})` : ""}`} value={`${p.admin_change < 0 ? "−" : "+"}${money(Math.abs(p.admin_change))}`} /> : null}
      <Row bold testid="pay-total" label={`Total for ${b.travellers.length} traveller(s)`} value={money(p.total)} />
    </div>
  );
};
